import { useEffect, type ReactNode } from 'react';

import { useThemeStore } from '@/lib/store/themeStore';

interface ThemeProviderProps {
    children: ReactNode;
}

const DARK_MEDIA_QUERY = '(prefers-color-scheme: dark)';

function resolveDataTheme(preference: 'light' | 'dark' | 'system'): 'light' | 'dark' {
    if (preference === 'system') {
        return window.matchMedia(DARK_MEDIA_QUERY).matches ? 'dark' : 'light';
    }
    return preference;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
    const preference = useThemeStore((state) => state.preference);

    useEffect(() => {
        const apply = () => {
            const resolved = resolveDataTheme(preference);
            document.documentElement.setAttribute('data-theme', resolved);
        };
        apply();
        if (preference !== 'system') return;
        const mql = window.matchMedia(DARK_MEDIA_QUERY);
        mql.addEventListener('change', apply);
        return () => mql.removeEventListener('change', apply);
    }, [preference]);

    return <>{children}</>;
}
